﻿import { defineComponent, PropType } from 'vue';

import { week_day } from "../../../../objects/front_end/calendar/week_day";
import { capacity_capacity } from "../../../../objects/v1_3/product/capacity/capacity_capacity";

import { Booking } from "../../../../services/booking";
import { Currency_Service } from "../../../../../system/services/currency";
import { Product } from '../../../../services/product';
import { Date_Service } from '../../../../../system/services/date_service';
import { Capacity } from '../../../../services/capacity';

const Prod = new Product();
const Capa = new Capacity();
const Date_Services = new Date_Service();
const Book = new Booking();
const Currency_Services = new Currency_Service();

export default defineComponent({
    name: "calendar_day",
    props: {
        day: Object as PropType<week_day>,
        selected_tour_id: String,
        trip_index: Number,
        addon_departure_dates: { type: Array as PropType<string[]>, default: () => [] },
        capacities: { type: Array as PropType<capacity_capacity[]>, default: () => [] }
    },
    data() {
        return {
            almostFull: false as boolean
        }
    },
    emits: [
        "dateChange"
    ],
    methods: {
        hasAddOn(): boolean {
            const addonIds = import.meta.env.VITE_CALENDAR_ADDON_IDS?.split(",").map((id: string) => id.trim().toUpperCase()) ?? [];
            if (!addonIds.length || !this.day?.date || !this.selected_tour_id) return false;

            const product_detail = Prod.Get_Details_Sync(this.selected_tour_id, this.$store);
            if (!product_detail?.seller_information?.add_ons) return false;

            let can_add = false;

            product_detail.seller_information.add_ons.forEach(addonGroup => {
                if (addonGroup.name == 'Add Ons') {
                    addonGroup.groups.forEach(group => {
                        if (addonIds.includes(group.products[0]?.tour_id?.toUpperCase())) {
                            if (!group.dates || group.dates.length == 0) {
                                can_add = true;
                            } else {
                                group.dates.forEach(daterange => {
                                    if (Date_Services.compare_dates_between(this.day?.date ?? null, daterange.date_from, daterange.date_to)) {
                                        can_add = true;
                                    }
                                });
                            }
                        }
                    });
                }
            });

            if (!can_add) return false;

            const searchDate = this.day.date.replaceAll("/", "-") + " ";
            return this.addon_departure_dates.some(d =>
                d.replaceAll("-0", "-").startsWith(searchDate)
            );
        },
        get_passangers_count(): number {
            let index = 0;
            this.$store.getters.get_Booking?.trips[this.get_Trip_Index()]?.passengers.forEach(pax => {
                index++;
            });
            return index;
        },
        getDay(): string {
            if (this.day == undefined) {
                return "";
            }

            if (this.day.totalCapacity == -1) {
                return "";
            }

            return String(this.day.number);
        },
        getSeats(): string {
            if (this.day == undefined) {
                return "";
            }

            if (this.day.totalCapacity == -1) {
                return "";
            }

            if (this.isFull() == true) {
                return "Full";
            }

            if (this.get_Total_Capacity() <= 3) {
                return "Last seats";
            }

            return ((this.get_Total_Capacity() > 5) ? "5 +" : String(this.get_Total_Capacity())) + " left";
        },
        isToday(): boolean {
            if(this.day?.is_today == true)
            {
                return true;
            }
            else
            {
                return false;
            }
        },
        getPrice(): string {
            if (this.day == undefined) {
                return "";
            }

            if (this.day.totalCapacity == -1) {
                return "";
            }

            if (this.day.fromPrice == -1) {
                return "";
            }

            return Currency_Services.Format_Currency(this.day.fromPrice, this.$store.getters.get_Currency);
        },
        display_day(): boolean {
            let retrurnval = true;

            if(this.getPrice() == "")
            {
                retrurnval = false;
            }
            if (this.day && this.day.fromPrice < 1)
            {
                retrurnval = false;
            }
            if(this.getSeats() == '')
            {
                retrurnval = false;
            }

            return retrurnval        
        },
        async date_selected() {
            if (this.day == undefined) {
                return;
            }

            if (this.day.totalCapacity == -1) {
                return;
            }

            if (this.isFull() == true) {
                return;
            }

            if(this.get_passangers_count() > this.get_Total_Capacity())
            {
                return;
            }

            this.$store.commit("Set_seats_free_selected_date", { Seats: this.get_Total_Capacity() });

            this.$emit("dateChange", this.day);

            this.$store.commit("Initialise_Basket_Departure", { Trip_Index: this.get_Trip_Index(), Departure_Date: this.day.date, Capacity: this.get_Booking_Capacity() });
            await Book.Setup_Booking(this.$store);
        },
        get_Booking_Capacity(): capacity_capacity | undefined {
            //a not for sale calendar tour is booked on the selected sales group option, so use that option's capacity for this date
            let Booking_Tour_Id = this.$store.getters.get_Basket?.trips[this.get_Trip_Index()]?.tour_id;
            if (!Prod.Is_Not_For_Sale(this.selected_tour_id ?? "", this.$store) || !Booking_Tour_Id || Booking_Tour_Id == this.selected_tour_id) {
                return this.day?.capacity_info;
            }

            return this.capacities.find(capa => capa.tour_id == Booking_Tour_Id && Date_Services.compare_date(capa.start_date_time) == Date_Services.compare_date(this.day?.output_date ?? null))
                ?? this.day?.capacity_info;
        },
        get_Total_Capacity(): number {
            //a not for sale calendar tour shows the seats left on the sales group option that is booked
            let Booking_Capacity = this.get_Booking_Capacity();
            if (this.day == undefined || this.day.totalCapacity == -1 || Booking_Capacity == undefined || Booking_Capacity == this.day.capacity_info) {
                return this.day?.totalCapacity ?? 0;
            }

            return Capa.Get_Free_Seats(Booking_Capacity);
        },
        isDate_Selected(): boolean {
            let Basket = this.$store.getters.get_Basket;

            let queryDate = this.GetDepartureDateFromQuery();
            let calendardate = this.day?.date?.replaceAll("/","-");
            let isQueryDateCalendarDate : boolean = (queryDate == calendardate);
            let isDateSelectedInBasket : boolean = false;
            if (this.get_Trip_Index() > -1 && Basket.trips[this.get_Trip_Index()] != undefined) {
                isDateSelectedInBasket= (Basket.trips[this.get_Trip_Index()].departure_date != null && Basket.trips[this.get_Trip_Index()].departure_date != "");
            }

            if (Basket.trips.length > this.get_Trip_Index())
            {
                if (Basket.trips[this.get_Trip_Index()].departure_date == this.day?.date) {
                    return true;
                }
                else if (isQueryDateCalendarDate && !isDateSelectedInBasket)
                {
                    this.date_selected();
                    return true;
                }
            }

            return false;
        },
        isFull(): boolean {
            if ((this.day?.totalCapacity ?? 0) == -1) {
                return false;
            }

            if (this.day?.tour_id.findIndex((f: string) => f == this.selected_tour_id) == -1) {
                return true;
            }
            if (this.get_Total_Capacity() <= 4) {
                this.almostFull = true;
            }

            return (this.get_Total_Capacity() == 0);
        },
        get_Trip_Index(): number {
            return this.trip_index ?? 0;
        },
        GetDepartureDateFromQuery() : string {
            let url = window.location.search.substring(1).replace("%20"," ");
            let params = url.split("&");
            let depDate = "";

            if(params.length > 0)
            {
                params.forEach((param: string) => {
                    if(param.includes("departuredate"))
                    {
                        depDate = param.split("=")[1];
                    }  
                });
            }

            return depDate;
        }
    },
    mounted() {
    }
})